import * as angular from "angular";
import {IController} from "angular";
import {LabelsRequestsService} from "../../services/labels-requests.service";

export class labelMultipleSelectFormCtrl implements IController {

  form: any;
  selectedLabelNames: any;
  options: any;
  ngPlaceholder: any;
  noUnderline: Function;
  isRequired: boolean;
  onLabelsChange: Function;

  private excludeLabelNames: any;

  /* @ngInject */
  constructor(private $mdSelect, private labelsRequestsService: LabelsRequestsService, private $log) {
  }

  $onInit() {
    if (!this.excludeLabelNames) {
      this.excludeLabelNames = [];
    }
    if (!this.options) {
      this.labelsRequestsService.getAll()
        .then((labels) => {
          this.options = labels;
        })
        .catch((error) => {
          this.$log.error('Failed to get labels', error);
        })
    }
  };

  //////////////////////////////////////////////////////////////////////////

  doneHideSelect() {
    this.$mdSelect.hide();
  }

  resetHideSelect() {
    this.$mdSelect.hide();
    this.selectedLabelNames = [];
    this.onLabelsChange({labels: []});
  }

}

angular
  .module('bringoz.admin.labels')
  .component('labelMultipleSelectForm', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedLabelNames: '<',
      options: '<?',
      ngPlaceholder: '@?',
      noUnderline: '@?',
      isRequired: '@?',
      onLabelsChange: '&'
    },
    template: require('./label-multiple-select-form.html').default,
    controller: labelMultipleSelectFormCtrl
  });
